import { BaseService } from './BaseService';
import {
  LocationsPageableQueryResult,
  LocationViewModel,
  LocationPosition,
  LocationStable,
  LocationAnimalsResult,
  LocationsHierarchyResult
} from '../models/locations';
import { AnimalType } from '../models/animal';
import { CreateEntityBatchResult } from '../models/common';

export class LocationsService extends BaseService {
  getLocationsByQuery = async (
    page: number,
    size: number,
    number: string,
    room: string,
    pen: string,
    position: LocationPosition,
    stable: LocationStable,
    animalType: AnimalType,
    sort?: string
  ): Promise<LocationsPageableQueryResult> => {
    const query = this.BuildQueryString({ page, size, number, room, pen, position, stable, animalType, sort });

    const result = await this.Fetch(`/locations/search?${query}`, 'GET');

    return this.FromResult<LocationsPageableQueryResult>(result);
  };

  getLocationsHierarchy = async (stable: LocationStable, animalType: AnimalType): Promise<LocationsHierarchyResult> => {
    const query = this.BuildQueryString({ stable, animalType });

    const result = await this.Fetch(`/locations/hierarchy${query ? `?${query}` : ''}`, 'GET');

    return this.FromResult<LocationsHierarchyResult>(result);
  };

  getLocationById = async (id: string): Promise<LocationViewModel> => {
    const result = await this.Fetch(`/locations?id=${id}`, 'GET');

    return this.FromResult<LocationViewModel>(result);
  };

  updateLocation = async (location: LocationViewModel): Promise<string> => {
    const result = await this.Fetch('/locations', 'PUT', JSON.stringify(location));

    return this.FromResult<string>(result);
  };

  createLocation = async (location: LocationViewModel): Promise<CreateEntityBatchResult> => {
    const result = await this.Fetch('/locations', 'POST', JSON.stringify(location));

    return this.FromResult<CreateEntityBatchResult>(result);
  };

  getLocationAnimals = async (locationId: string): Promise<LocationAnimalsResult> => {
    const query = this.BuildQueryString({ locationId });

    const result = await this.Fetch(`/locations/animals?${query}`, 'GET');

    return this.FromResult<LocationAnimalsResult>(result);
  };
}

export default LocationsService;
